import { render } from "./FormRow.vue?vue&type=template&id=4b5da188"
import script from "./FormRow.vue?vue&type=script&lang=js"
export * from "./FormRow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__